module.exports = __webpack_public_path__ + "static/media/the-panel.d30b9e2e.png";